import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ServiceProductService } from '../service-product.service';
import { ServiceProductComponent } from '../service-product/service-product.component';
import { ServiceProduct } from '../service-product';

@Component({
    selector: 'app-service-product-list',
    templateUrl: './service-product-list.component.html',
    styleUrls: ['./service-product-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ServiceProductListComponent implements OnInit {
	//location: any;
	constructor(
		private serviceProductService: ServiceProductService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.locations = serviceProductService.locations,
     	this.listingStatus = serviceProductService.listingStatus,
     	this.categories = serviceProductService.categories,
     	this.codes = serviceProductService.codes
	}




	// data
	serviceProducts: any;
	serviceProduct: ServiceProduct;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	//statuses: any;
	locations: any;
	codes: any;
	listingStatus: any;
	categories: any;


	columns: any[] = [
		{ field: 'serviceProductId', header: 'Id', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'listingStatus', header: 'Listing Status', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.serviceProductId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-serviceProduct-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.serviceProductService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.serviceProducts = res.data.serviceProducts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.serviceProducts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(serviceProduct: ServiceProduct) {
		try {
			this.formLoading = true;
			this.serviceProductService.update(serviceProduct)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.serviceProducts.map((serviceProduct, i) => {
							if (serviceProduct.serviceProductId === res.data.serviceProduct.serviceProductId) {
								this.serviceProducts[i] = res.data.serviceProduct;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(serviceProduct: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(serviceProduct));

			this.formLoading = true;
			this.serviceProductService.delete(serviceProduct.serviceProductId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.serviceProducts.splice(this.serviceProducts.indexOf(serviceProduct), 1);
						this.recordTotal = this.serviceProducts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ServiceProduct ' + serviceProduct.serviceProductId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ServiceProduct ' + serviceProduct.serviceProductId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ServiceProduct'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ServiceProductComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addServiceProductCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(serviceProduct: ServiceProduct) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			serviceProduct: serviceProduct,
			title: 'Edit ServiceProduct'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ServiceProductComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateServiceProductCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteServiceProductCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addServiceProductCB(serviceProduct: ServiceProduct) {
		console.log('Adding ServiceProduct: ' + JSON.stringify(serviceProduct));
		// if we don't have a serviceProducts array yet...
		if (!this.serviceProducts) {
			this.serviceProducts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.serviceProducts.unshift(serviceProduct);

		// no idea what this is but it is required to update the array
		this.serviceProducts = [...this.serviceProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ServiceProduct ' + serviceProduct.serviceProductId + ' Added', life: 3000 });
	}

	updateServiceProductCB(serviceProduct: ServiceProduct) {
		console.log('Updating ServiceProduct: ' + JSON.stringify(serviceProduct));
		let itemIndex = this.serviceProducts.findIndex((item: any) => item.serviceProductId === serviceProduct.serviceProductId);
		this.serviceProducts[itemIndex] = serviceProduct;

		// no idea what this is but it is required to update the array
		this.serviceProducts = [...this.serviceProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ServiceProduct ' + serviceProduct.serviceProductId + ' Updated', life: 3000 });
	}

	deleteServiceProductCB(serviceProduct: ServiceProduct) {
		console.log('Removing ServiceProduct: ' + serviceProduct);
		this.serviceProducts.splice(this.serviceProducts.indexOf(serviceProduct), 1);
		this.recordTotal = this.serviceProducts.length;

		// no idea what this is but it is required to update the array
		this.serviceProducts = [...this.serviceProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ServiceProduct ' + serviceProduct.serviceProductId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.serviceProducts ? this.first === (this.serviceProducts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.serviceProducts ? this.first === 0 : true; }

	get Statuses() {
		return this.listingStatus;
	}

	getStatusName(serviceProduct: any) {
		if (serviceProduct?.status) {
			const status = this.listingStatus.find((e: any) => e.value == serviceProduct.listingStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator() {
		return true;
	}
}
